import React from "react";

export const WhatsAppChat = ({ phone }) => {
  if (!phone) {
    return null;
  }

  // Extract the first phone number and remove non-digit characters
  const phoneNumber = phone.split(",")[0].replace(/\D/g, "");
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  const style = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    color: "white",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "2px 2px 6px rgba(0,0,0,0.4)",
    zIndex: 1000,
    fontSize: "30px",
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
    >
      <i className="fa fa-whatsapp"></i>
    </a>
  );
};